import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

let newRelicAgent: BrowserAgent | undefined;
initNewRelicApm();

function checkIsApmEnabled() {
  // @TODO: Change to use feature-flags similar to segment.
  return import.meta.env.VITE_NEW_RELIC_ENABLED === 'true';
}

function initNewRelicApm() {
  if (!checkIsApmEnabled()) {
    return;
  }

  const {
    VITE_NEW_RELIC_TRACING_ORIGINS,
    VITE_NEW_RELIC_LICENSE_KEY,
    VITE_NEW_RELIC_APPLICATION_ID,
    VITE_NEW_RELIC_ACCOUNT_ID,
    VITE_NEW_RELIC_TRUST_KEY,
    VITE_ENV,
    VITE_THEME,
    VITE_APP_VERSION,
  } = import.meta.env;

  try {
    newRelicAgent = new BrowserAgent({
      init: {
        distributed_tracing: {
          enabled: true,
          cors_use_newrelic_header: true,
          cors_use_tracecontext_headers: true,
          allowed_origins: VITE_NEW_RELIC_TRACING_ORIGINS.split(','),
        },
        jserrors: {
          enabled: true,
        },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.nr-data.net'] },
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: VITE_NEW_RELIC_LICENSE_KEY,
        applicationID: VITE_NEW_RELIC_APPLICATION_ID,
        sa: 1,
      },
      loader_config: {
        accountID: VITE_NEW_RELIC_ACCOUNT_ID,
        trustKey: VITE_NEW_RELIC_TRUST_KEY,
        agentID: VITE_NEW_RELIC_APPLICATION_ID,
        licenseKey: VITE_NEW_RELIC_LICENSE_KEY,
        applicationID: VITE_NEW_RELIC_APPLICATION_ID,
      },
    });

    newRelicAgent.setCustomAttribute('STAGE', VITE_ENV, true);
    newRelicAgent.setCustomAttribute('WLP', VITE_THEME, true);
    newRelicAgent.setCustomAttribute('version', VITE_APP_VERSION, true);
  } catch (error) {
    console.error(error);
  }
}
